if (navigator && navigator.serviceWorker) {
  navigator.serviceWorker
    .getRegistrations()
    .then(function (registrations) {
      for (const registration of registrations) {
        registration.unregister()
      }
    })
    .catch(function (err) {
      console.log('Service Worker get registrations failed: ', err)
    })
} else {
  console.log('Falha ao desabilitar service worker')
}